import { Block, Typography } from '@xprog/prensa';
import IconButton from 'components/Buttons/IconButton.index';
import React, { useEffect, useRef } from 'react';
import { useIcon } from 'hooks/useIcon';
import { useImageProxy } from 'hooks/useImageProxy';
import { WidgetTypes, WIDGET_TYPES } from 'hooks/useGCJAnalytics';
import useOnScreen from 'hooks/useOnScreen';

export type EditionFeaturedProps = {
  children?: any;
  className?: string;
  customProps?: {
    className?: string;
  };
  contentData?: [any];
  slotTemplateCode?: string;
  handleSendClickEvent: (type: WidgetTypes) => void;
  handleSendViewEvent: (type: WidgetTypes) => void;
};

const dataProps = {
  headTitle1: 'Edição Digital',
};

const EditionFeatured: React.FC<EditionFeaturedProps> = (props) => {
  const className = props.customProps?.className;
  const baseClassName = `EditionFeatured ${
    props?.className || ''
  } ${className}`;
  const isDesktop = props?.customProps?.className?.includes('desktop');
  const iconVersaoDigitalProps = useIcon('IcVersaoDigitalCinzaClaro');
  const editionImagePath = useImageProxy(props?.contentData?.[0]?.url, true);
  const editionLink = props?.slotTemplateCode;
  const ref = useRef<HTMLDivElement>(null);
  const isVisible = useOnScreen(ref);

  useEffect(() => {
    if (isVisible) {
      props.handleSendViewEvent(WIDGET_TYPES.EDICAO_DIGITAL);
    }
  }, [isVisible]);

  if (isDesktop) return <></>;
  return (
    <Block
      ref={ref}
      className={baseClassName}
      css={{
        align: ['column', 'center', 'middle'],
        mb: '$8',
        width: '100%',
      }}
      onClick={() => props.handleSendClickEvent(WIDGET_TYPES.EDICAO_DIGITAL)}
    >
      <Block
        className={baseClassName}
        css={{
          align: ['column', 'center', 'top'],
          backgroundColor: '#f4f4f4',
          width: '100%',
        }}
      >
        <Typography
          as='h2'
          css={{
            align: ['row', 'center', 'middle'],
            color: '#4d4d4d',
            fontSize: '22px',
            fontWeight: 600,
            lineHeight: '24px',
            fontFamily: '$primary',
            mt: '$4',
            mb: '$2',
            pl: '$0',
            width: '100%',
            img: {
              width: '32px',
            },
            span: {
              ml: '$1',
            },
          }}
        >
          <IconButton icon={iconVersaoDigitalProps} />
          <span>{dataProps.headTitle1}</span>
        </Typography>
        <Block
          css={{
            align: ['column', 'center', 'middle'],
            borderTop: '1px solid black',
            width: 'calc(100% - $12)',
            img: {
              mt: '$4',
              mb: '$4',
              width: '168px',
            },
          }}
        >
          <a
            href={editionLink}
            rel='noreferrer'
            target='_blank'
            title='Clique para abrir a Edição Digital'
          >
            <img src={editionImagePath} alt='Edição do dia' />
          </a>
        </Block>
      </Block>
    </Block>
  );
};

export default EditionFeatured;
